import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { AddPolicyComponent } from '../../../../components/forms/dynamic-forms/add-policy/add-policy.component';
import { PolicySvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/policy-svg/policy-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { Component, OnInit } from '@angular/core';

import { AddPolicyService } from '../../../../_services/forms/create-account/add-policy.service';
import { UserService } from '../../../../_services/user.service';
import { Router , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, PolicySvgComponent, AddPolicyComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-signup-add-policy',
  templateUrl: './signup-add-policy.component.html',
})
export class SignupAddPolicyComponent implements OnInit {
  addPolicy: any[];
  whereToFindModalOptions: ModalOptions;
  isAcmic: boolean;

  constructor(
    private policyService: AddPolicyService,
    private router: Router,
    private userService: UserService,
    private acmicService: AcmicService
  ) {
    this.isAcmic = false;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.addPolicy = this.policyService.getInputs();
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small center-on-page modal-dialog',
      additionalButtonClasses: `no-padding-horizontal link-button ${
        this.isAcmic
          ? 'blue-link font-weight normal-text text-capitalize small underline'
          : 'red-link underlineBQ commercial-find-pol dm-sans-medium font-weight-500 underlineBQ'
      }`,
      animatePosition: 'bottom',
      buttonCopy: 'MODAL_WHERE_CAN_I_LINK_ADD_POLICY',
      modalId: 'helpModal',
      modalTranslateCopy: 'LOCATE_YOUR_POLICY_INFORMATION',
      typeOfModal: 'default',
      modalName: 'signup-add_Where_To_Find_Options',
    });
  }

  navigateBack() {
    const isCommercialAc = this.userService.getCommercialAcFlag();
    if (isCommercialAc) {
      this.router.navigate(['signup/create-commercial-account']);
    } else {
      this.router.navigate(['signup']);
    }
  }
}
